import Menu  from '../menu/menu';
import React from 'react';

export default class Tab extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state         = {
      lastVisited: {}
    };
    this.onRouteChange = this.onRouteChange.bind(this);
    this.navigateTo    = this.navigateTo.bind(this);
  }

  componentDidMount() {
    this.$f7ready(f7 => {
      f7.router.app.on('routeChange', this.onRouteChange);
    });
  }

  componentWillUnmount() {
    this.$f7ready(f7 => {
      f7.router.app.off('routeChange', this.onRouteChange);
    });
  }

  onRouteChange(newRoute) {
    // @TODO root page behaves strange...
    if (newRoute.path === '/')
      return;

    const tab            = newRoute.route.tabComponent;
    const { businessID } = newRoute.params;

    this.setState({
      businessID,
      tabActive: newRoute.name,
      params:    newRoute.params,
      query:     newRoute.query,
      tab
    });
  }

  navigateTo(path, options) {
    const app = this.$f7;
    app.methods.navigateTo({ app, path, options });
  }

  render() {
    const { tab } = this.state;

    if (!tab)
      return null;

    const { params }    = this.state;
    const { query }     = this.state;
    const { tabActive } = this.state;
    const { name }      = tab;
    const CurrentTab    = tab.component;

    return (
      <div className="view view-tabs">
        <Menu tab={name} businessID={params.businessID} navigateTo={this.navigateTo}/>
        <CurrentTab tabActive={tabActive} query={query} {...params}/>
      </div>
    );
  }
}
